import { useEffect, useRef, useState } from "react";

const QUESTIONS = [
  "Hey Omi, jusqu'à quand mon frigo est garanti ?",
  "Hey Omi, quand dois-je changer la pile du détecteur ?",
  "Hey Omi, quand ai-je changé mes pneus ?",
  "Hey Omi, dans combien de km dois-je faire ma révision ?",
  "Hey Omi, retrouve-moi la facture de ma télé.",
  "Hey Omi, qui a installé ma clim ?",
  "Hey Omi, où est la notice du lave-vaisselle ?",
  "Hey Omi, quels appareils arrivent en fin de garantie ?",
  "Hey Omi, combien me coûtent mes contrats ?",
  "Hey Omi, quelle est ma franchise d'assurance ?",
  "Hey Omi, quand ai-je acheté mon téléphone ?",
  "Hey Omi, qu'est-ce que je dois faire cette semaine ?",
  "Hey Omi, ma chaudière est-elle sous contrat ?",
  "Hey Omi, quand est mon prochain contrôle technique ?",
  "Hey Omi, rappelle-moi de prendre mon traitement ce soir.",
  "Hey Omi, quel est le numéro de série de mon four ?",
  "Hey Omi, mes fenêtres sont-elles encore garanties ?",
  "Hey Omi, quand ai-je fait vidanger la voiture ?",
];

const POS = [
  { top: "8%", left: "3%", delay: 0, anim: "floatY" },
  { top: "15%", left: "70%", delay: 0.8, anim: "floatY2" },
  { top: "31%", left: "1%", delay: 1.4, anim: "floatY2" },
  { top: "41%", left: "79%", delay: 0.4, anim: "floatY" },
  { top: "63%", left: "5%", delay: 1.1, anim: "floatY" },
  { top: "72%", left: "71%", delay: 0.2, anim: "floatY2" },
  { top: "53%", left: "40%", delay: 1.7, anim: "floatY2" },
  { top: "85%", left: "33%", delay: 0.9, anim: "floatY" },
  { top: "5%", left: "40%", delay: 1.3, anim: "floatY" },
  { top: "88%", left: "60%", delay: 0.6, anim: "floatY2" },
  { top: "24%", left: "35%", delay: 2.0, anim: "floatY" },
  { top: "47%", left: "18%", delay: 1.5, anim: "floatY2" },
];

const MOBILE_POS = [
  { top: "3%", left: "4%", delay: 0, anim: "floatY" },
  { top: "10%", left: "45%", delay: 0.7, anim: "floatY2" },
  { top: "18%", left: "9%", delay: 1.3, anim: "floatY" },
  { top: "77%", left: "42%", delay: 0.4, anim: "floatY2" },
  { top: "85%", left: "5%", delay: 1.0, anim: "floatY" },
  { top: "92%", left: "46%", delay: 0.5, anim: "floatY2" },
];

const pickDistinct = (exclude) => {
  const pool = QUESTIONS.filter((q) => !exclude.includes(q));
  const src = pool.length ? pool : QUESTIONS;
  return src[Math.floor(Math.random() * src.length)];
};

export function Bubbles({ onPick }) {
  const [slots, setSlots] = useState([]);
  const [highlight, setHighlight] = useState(-1);
  const [isMobile] = useState(() => typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches);
  const POSITIONS = isMobile ? MOBILE_POS : POS;

  useEffect(() => {
    const used = [];
    const init = POSITIONS.map(() => { const q = pickDistinct(used); used.push(q); return { q, shown: false }; });
    setSlots(init);
    const timers = init.map((_, i) =>
      setTimeout(() => setSlots((s) => s.map((x, j) => (j === i ? { ...x, shown: true } : x))), 350 + i * 170));
    return () => timers.forEach(clearTimeout);
  }, []);

  useEffect(() => {
    const swap = setInterval(() => {
      setSlots((s) => {
        if (!s.length) return s;
        const i = Math.floor(Math.random() * s.length);
        setTimeout(() => {
          setSlots((cur) => {
            const nq = pickDistinct(cur.map((x) => x.q));
            return cur.map((x, j) => (j === i ? { q: nq, shown: true } : x));
          });
        }, 520);
        return s.map((x, j) => (j === i ? { ...x, shown: false } : x));
      });
    }, 2600);

    const hi = setInterval(() => {
      const i = Math.floor(Math.random() * POSITIONS.length);
      setHighlight(i);
      setTimeout(() => setHighlight((cur) => (cur === i ? -1 : cur)), 2600);
    }, 4300);

    return () => { clearInterval(swap); clearInterval(hi); };
  }, []);

  return (
    <div className="absolute inset-0" aria-hidden="false">
      {slots.map((slot, i) => {
        const p = POSITIONS[i];
        const hi = highlight === i;
        return (
          <div key={i} className="absolute" style={{
            top: p.top, left: p.left, zIndex: hi ? (isMobile ? 2 : 30) : (isMobile ? 1 : 10),
            animation: slot.shown ? `${p.anim} ${7 + (i % 4)}s ease-in-out ${p.delay}s infinite` : "none",
          }}>
            <button
              data-testid={`hero-bubble-${i}`}
              onClick={() => onPick && onPick(slot.q)}
              className={`text-left omy-glass rounded-2xl px-3.5 py-2.5 text-xs md:px-4 md:py-3 md:text-sm cursor-pointer hover:text-white hover:border-primary/50 ${
                hi ? "text-white omy-glow border-primary/60" : "text-foreground/90"}`}
              style={{
                maxWidth: isMobile ? (hi ? 210 : 172) : (hi ? 300 : 230),
                opacity: slot.shown ? (hi ? 1 : (isMobile ? 0.75 : 0.88)) : 0,
                transform: `translateY(${slot.shown ? 0 : 14}px) scale(${hi ? 1.14 : 1})`,
                transition: "opacity 0.5s ease, transform 0.5s cubic-bezier(0.22,1,0.36,1), max-width 0.5s ease",
              }}>
              <span className="font-display font-medium">{slot.q}</span>
            </button>
          </div>
        );
      })}
    </div>
  );
}

export function VoiceWave({ active = true, bars = 5 }) {
  return (
    <div className="flex items-end gap-1 h-6">
      {Array.from({ length: bars }).map((_, i) => (
        <span
          key={i}
          className="wave-bar"
          style={{ animationDelay: `${i * 0.12}s`, animationPlayState: active ? "running" : "paused" }}
        />
      ))}
    </div>
  );
}
